import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { ModalOverlay } from '@/components/ui/modalOverlay';
import { Textarea } from '@/components/ui/textarea';

interface RescheduleRequestDialogProps {
  isSubmitting: boolean;
  onConfirm: (message: string) => void;
  onCancel: () => void;
}

export function RescheduleRequestDialog({
  isSubmitting,
  onConfirm,
  onCancel,
}: RescheduleRequestDialogProps) {
  const { t } = useTranslation(['clients', 'common']);
  const [message, setMessage] = useState('');
  const isValid = message.trim().length > 0;

  return (
    <ModalOverlay onRequestClose={onCancel} variant="sheet">
      <div className="w-full sm:max-w-md max-h-[92dvh] overflow-y-auto bg-zoowhite border border-zooborder rounded-t-3xl sm:rounded-3xl shadow-2xl p-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] sm:pb-6">
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4 bg-zoovpalelavender">
          <Icon name="RefreshCw" className="text-xl text-zooprimary" />
        </div>
        <h2 className="text-lg font-bold text-zooindigo">{t('clients:visits.rescheduleDialog.title')}</h2>
        <p className="text-sm text-zoomuted mt-1.5">{t('clients:visits.rescheduleDialog.hint')}</p>
        <div className="space-y-1.5 mt-4">
          <Label htmlFor="visit-reschedule-message">
            {t('clients:visits.rescheduleDialog.messageLabel')}
          </Label>
          <Textarea
            id="visit-reschedule-message"
            rows={3}
            value={message}
            placeholder={t('clients:visits.rescheduleDialog.messagePlaceholder')}
            onChange={function update(changeEvent) {
              setMessage(changeEvent.target.value);
            }}
          />
        </div>
        <div className="flex gap-3 mt-6">
          <Button
            type="button"
            variant="outline"
            className="flex-1"
            disabled={isSubmitting}
            onClick={onCancel}
          >
            {t('common:actions.cancel')}
          </Button>
          <Button
            type="button"
            className="flex-1"
            disabled={isValid === false}
            isLoading={isSubmitting}
            onClick={function confirm() {
              onConfirm(message.trim());
            }}
          >
            {t('clients:visits.rescheduleDialog.confirm')}
          </Button>
        </div>
      </div>
    </ModalOverlay>
  );
}
